import { countries } from 'platform/forms/address';

/**
 * Formats an addressUI-shaped address into a single display string,
 * e.g. "123 Main St, Apt 4, Portland, OR 97201".
 *
 * @param {Object} address - addressUI-shaped form data address
 * @returns {string} Formatted address string
 */
export const formatAddress = address => {
  if (!address) return '';

  const { street, street2, street3, city, state, postalCode, country } =
    address;

  let display = '';
  if (street) display += street;
  if (street2) display += `, ${street2}`;
  if (street3) display += `, ${street3}`;
  if (city) display += `, ${city}`;
  if (state) display += `, ${state}`;
  if (postalCode) display += ` ${postalCode}`;
  if (country && country !== 'USA') {
    const label = countries.find(c => c.value === country)?.label || country;
    display += `, ${label}`;
  }

  return display.trim();
};
